import { Maybe } from '@kinetic-ui/data-layer';
import {
  Dispatch,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';
import { PickedObject } from '../DeckGlMapContainer/types';

export type TooltipPickingInfo<TData = unknown> =
  | Pick<PickedObject<TData>, 'object' | 'picked' | 'x' | 'y'>
  // passing { picked: false } is all thats needed trigger unhover.
  | { picked?: false; object?: never; x?: never; y?: never };

type MapTooltipContextValue<TData = unknown> = {
  hovered: TooltipPickingInfo<TData> | null;
  onHover: Dispatch<TooltipPickingInfo<TData>>;
};
const MapTooltipContext = createContext<Maybe<MapTooltipContextValue>>(null);

export const MapTooltipProvider = ({ children }: PropsWithChildren<{}>) => {
  const [hovered, setHovered] = useState<Maybe<TooltipPickingInfo<unknown>>>(null);

  const onHover = useCallback((info: TooltipPickingInfo) => {
    if (info.picked) {
      setHovered(info);
    } else {
      setHovered(null);
    }
  }, []);

  return (
    <MapTooltipContext.Provider value={{ hovered, onHover }}>{children}</MapTooltipContext.Provider>
  );
};

export const useMapTooltipContext = <TData extends unknown = unknown>() => {
  const context = useContext(MapTooltipContext);
  if (!context) {
    throw new Error('Cannot find MapTooltipContext');
  }
  return context as MapTooltipContextValue<TData>;
};
